import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, Slot } from "@builder.io/qwik";
const HAccordionHeader = component$(({ as = "h3", ...props }) => {
  const PolymorphicHeading = as;
  return /* @__PURE__ */ jsx(PolymorphicHeading, {
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HAccordionHeader
};
